import React, { useState } from 'react';
import { Col, Row, Tag } from 'antd';
import styles from '../index.less';

const RenderTags = ({ name, tags }) => {
  const [showAllTags, setShowAllTags] = useState(false);
  return (
    <Row gutter={12} wrap={false}>
      <Col span={10}>
        <p className={styles.tagsTitle}>{name}</p>
      </Col>
      {/* //~IF ONLY ONE TAG THEN SHOW JUST FIRST INDEX */}
      {tags.length === 1 && (
        <Col span={14}>
          <Tag
            color="blue"
            style={{
              marginBottom: 12,
            }}
          >
            {tags[0]}
          </Tag>
        </Col>
      )}
      {/* //~IF MORE THAN ONE TAG THEN SHOW FIRST TAG WITH SHOW MORE ACTION */}
      {!showAllTags && tags.length > 1 && (
        <Col span={14}>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'flex-start',
            }}
          >
            <Tag
              color="blue"
              style={{
                marginBottom: 12,
              }}
            >
              {tags[0]}
            </Tag>
            <p onClick={() => setShowAllTags(true)}>
              <span style={{ fontSize: '13px', color: '#096dd9', cursor: 'pointer' }}>
                Show {tags.length - 1} more
              </span>
            </p>
          </div>
        </Col>
      )}
      {/* //~IF SHOW MORE THAN STATE IS TRUE THEN SHOW ALL TAGS AND LESS ACTION */}
      {showAllTags && (
        <Col span={14}>
          {tags.map((tag, i) => (
            <Tag
              key={i}
              color="blue"
              style={{
                marginBottom: 12,
              }}
            >
              {tag}
            </Tag>
          ))}
          <p onClick={() => setShowAllTags(false)}>
            <span style={{ fontSize: '13px', color: '#096dd9', cursor: 'pointer' }}>Show less</span>
          </p>
        </Col>
      )}
    </Row>
  );
};

export default RenderTags;
